import { z } from 'zod';

export const SMTP_PORT_TLS = 465;
export const SMTP_PORT_STARTTLS = 587;

export const SmtpPublicSchema = z.object({
	host: z.string(),
	port: z.number().int(),
	secure: z.boolean(),
	user: z.string(),
	fromName: z.string(),
	fromAddress: z.string(),
	hasPassword: z.boolean(),
}).strip();

export const SmtpUpdateSchema = z.object({
	host: z.string().trim().min(1, 'Vui lòng nhập máy chủ SMTP').max(255, 'Máy chủ quá dài'),
	port: z.number({ invalid_type_error: 'Cổng phải là số' })
		.int('Cổng phải là số nguyên')
		.min(1, 'Cổng từ 1 đến 65535')
		.max(65535, 'Cổng từ 1 đến 65535'),
	secure: z.boolean(),
	user: z.string().trim().min(1, 'Vui lòng nhập tài khoản SMTP').max(255, 'Tài khoản quá dài'),
	/** Omitted = keep the stored password. */
	pass: z.string().min(1).max(1024, 'Mật khẩu quá dài').optional(),
	fromName: z.string().trim().min(1, 'Vui lòng nhập tên người gửi').max(100, 'Tên người gửi quá dài'),
	fromAddress: z.string().trim().min(1, 'Vui lòng nhập địa chỉ gửi').email('Địa chỉ gửi không hợp lệ'),
}).strip();

export const SmtpTestSchema = z.object({
	to: z.string().trim().email('Email nhận không hợp lệ').optional(),
}).strip();

export const SmtpTestResultSchema = z.object({
	sent: z.boolean(),
}).strip();

export type SmtpPublic = z.infer<typeof SmtpPublicSchema>;
export type SmtpUpdate = z.infer<typeof SmtpUpdateSchema>;
export type SmtpTest = z.infer<typeof SmtpTestSchema>;
